import * as React from 'react';
import '../scss/index.scss';
import Dialog from '@/pages/components/dialog';
import { parse } from 'query-string';
import request from '@/server/request';
import config from '@/server/config';
import store from '@/redux';
import * as confirmStore from '@/redux/ui/confirm';
const Toast = require('react-toast-mobile');

export default class CommodityTypes extends React.Component<any, any> {
	private companyId = parse(this.props.location.search).cid || ''; // 企业id
	private cateId:number = Number(parse(this.props.location.search).cateid || 0); // 大分类id
	private activeCateId:number|string = ''; // 活跃的分类id，正在编辑或者获取的分类id
	private editIndex:number = -1; // 编辑索引
	private moveChaning: boolean = false;

	constructor(props: any) {
		super(props);
		this.state = {
			level: Number(parse(this.props.location.search).level || 1),
			showAddBox: false,
			showRemoveBox: false,
			list: [], // 数据列表
			editValue: '', // 编辑值
			cate2Name: '' // 二级分类名称
		};
	}

	public componentDidMount() {
		this.getData();
	}

	public componentWillReceiveProps(props: any) { 
		const level = Number(parse(props.location.search).level || 1);
		const cid = parse(props.location.search).cid || '';
		const cateid = Number(parse(props.location.search).cateid || 0);

		if (level === this.state.level && cid === this.companyId) { 
			return;
		}

		if (cateid) { 
			this.cateId = cateid;
		}
		this.setState({
			level,
			list: [],
			cate2Name: level === 1 ? '' : this.state.cate2Name
		}, () => { 
				this.getData();
		});

	}

	public render() {
		const state = this.state;
		return (
			<div className="gray-bg page-commodityTypes">
				<Dialog visiblity={this.state.showAddBox}>
					<div className="fill-box">
						<p className="fill-title">{this.editIndex === -1 ? '新增' : '编辑'}分类</p>
						<div className="types-input-box">
							<input type="text" className="types-input" placeholder="不超过10个字" maxLength={10} defaultValue={state.editValue} onChange={() => this.changeEditValue()} />
						</div>
						<div className="fill-btn">
							<button className="btn" onClick={() => this.cancelEdit()}>取消</button>
							<button className="btn font-blod" onClick={() => this.confirmEdit()}>确定</button>
						</div>
					</div>
				</Dialog>
				<Dialog visiblity={this.state.showRemoveBox}>
					<div className="fill-box">
						<p className="fill-title">提示</p>
						<p className="types-prompt">
							确定要删除当前分类和当前分类下的子分类？
						</p>
						<div className="fill-btn">
							<button className="btn">取消</button>
							<button className="btn font-blod" onClick={() => this.changeState('showRemoveBox', false)}>确定</button>
						</div>
					</div>
				</Dialog>

				<p className="types-title">
					<span>全部</span>
					{
						state.cate2Name ? <span>>{state.cate2Name}</span> : null
					}
				</p>
				<div className="types-list">
					{
						state.list.map((v: any, k: number) => { 
							return (
								<div className="item" key={v.cate_id}>
									<p className="name" onClick={() => this.toChildrenList(v.cate_id, v.cate_name)}>
										<span className="text">{v.cate_name}</span>
										{
											state.level < 2 ? <i className="right-icon"/> : null
										}
									</p>
									<div className="types-bottom">
										<button className="btn blue" onClick={() => this.edit(v.cate_id, k, v.cate_name)}>修改分类名</button>
										<button className="btn red" onClick={() => this.delete(v.cate_id, k)}>删除</button>
										{
											k > 0 && <button className="btn blue" onClick={() => this.move(1,v.cate_id, k)}>上移</button>
										}
										{
											k < state.list.length-1 && <button className="btn blue" onClick={() => this.move(-1,v.cate_id, k)}>下移</button>
										}
									</div>
								</div>
							)
						})
					}
					
				</div>
				<div className="bottom">
					<button className="btn" onClick={() => this.goBack()}>{['返回商品列表', '返回全部分类', '返回上一级分类'][state.level-1]}</button>
					<button className="btn blue" onClick={() => this.add()}>新增{['一', '二', '三'][state.level-1]}级分类</button>
				</div>
			</div>
		)
	}

	// 获取页面数据
	private async getData() { 
		let url = '';
		let data = {};
		if (this.state.level === 1) { 
			url = `${config.MALLAPI}api/wshop/shop/cate`;
			data = {
				companyId: this.companyId
			};
		} else { 
			url = `${config.MALLAPI}api/shop/goods/child-cate`;
			data = {
				id: this.cateId
			};
		}
		const r = await request({
			url,
			method: 'post',
			data
		});
		
		if (r.error_code === 0) {
			this.setState({
				list: r.data
			});
		}

	}

	// 更新state
	private changeState(k: string, v: any) {

		this.setState({
			[k]: v
		})
		
	} 

	/**
	 * 跳转到下一级
	 * @param {number} 分类id
	 * @param {string} 分类名称
	 */
	private toChildrenList(cateId: number, cateName: string) {

		const level = this.state.level;

		if (level === 2) { 
			return;
		}
		let modelName = (level === 1) ? 'cate2Name' : 'cate3Name';
		
		this.setState({
			[modelName]: cateName
		}, () => { 
			this.props.history.push(`/store/commodityMangement/types?cid=${this.companyId}&level=${level + 1}&cateid=${cateId}`);
		});

	}

	// 返回上一级
	private goBack() { 
		this.props.history.goBack();
	}

	/**
	 * 编辑
	 * @param cateId {number} 分类id
	 * @param index {number} 分类索引
	 * @param cateName {number} 分类名称
	 */
	private edit(cateId: number, index: number, cateName: string) { 

		this.editIndex = index;
		this.activeCateId = cateId;
		this.setState({
			showAddBox: true,
			editValue: cateName
		});

	}

	// 新增
	private add() { 
		this.setState({
			showAddBox: true,
			editValue: ''
		});
	}

	/**
	 * 删除
	 * @param cateId {number} 分类id
	 * @param index {number} 索引
	 */
	private delete(cateId: number, index: number) { 
		store.dispatch({
			type: confirmStore.types.CONFIRM_SHOW,
			data: {
				text: '确定要删除当前分类和当前分类下的子分类？',
				onConfirm: () => { 
					this.editIndex = index;
					this.activeCateId = cateId;
					this.deleteAction();
				}
			}
		});
	}

	// 删除处理
	private async deleteAction() { 
		const r = await request({
			url: `${config.MALLAPI}api/shop/goods/cate-operate`,
			method: 'post',
			data: {
				companyId: this.companyId,
				cate_id: this.activeCateId,
				parent_id: this.cateId,
				is_delete: 1
			}
		});

		if (r.error_code === 0) {

			const temp = this.state.list;
			temp.splice(this.editIndex, 1);

			this.setState({
				list: temp
			});

		} else { 
			Toast.T.notify(r.msg);
		}

		this.cancelEdit();
	}

	// 改变编辑值
	private changeEditValue() { 

		this.setState({
			editValue: (event as any).target.value
		});

	}

	// 取消编辑
	private cancelEdit() { 
		this.editIndex = -1;
		this.activeCateId = '';
		this.setState({
			showAddBox: false
		});
	}

	// 确认编辑
	private async confirmEdit() { 

		const editValue = this.state.editValue;
		if (editValue === '') {
			return Toast.T.notify('请输入分类名称');
		} else if (editValue.length > 10) { 
			return Toast.T.notify('分类名称不能超过10个字');
		}

		const r = await request({
			url: `${config.MALLAPI}api/shop/goods/cate-operate`,
			method: 'post',
			data: {
				companyId: this.companyId,
				cate_id: this.activeCateId,
				cate_name: editValue,
				parent_id: this.cateId
			}
		});

		if (r.error_code === 0) { 

			this.setState({
				editValue: ''
			});
			this.getData();

		} else { 
			Toast.T.notify(r.msg);
		}

		this.cancelEdit();

	}

	/**
	 * [move 移动排序]
	 * @param  type:   number        [类型，上移，下移]
	 * @param  cateId: number        [分类id]
	 * @param  index:  number        [索引]
	 */
	private move(type: number, cateId: number, index: number) {
		if (this.moveChaning) return;
		this.moveChaning = true;
		Toast.T.loading();
		let list = this.state.list;
		const otherIndex = (type === 1 ? index-1 : index+1);
		request({
			url: config.MALLAPI + `api/wshop/default/category-sort`,
			method: 'post',
			data: {
				cid:cateId,
				replace: list[otherIndex].cate_id
			}
		}).then(r => {
			if (r.error_code === 0) {
				[list[index], list[otherIndex]] = [list[otherIndex], list[index]];
				this.setState({ list });
			}
			this.moveChaning = false;
			Toast.T.loaded();
		});
		
	}
}